import { NullableDateString, parseDate } from '@superdispatch/dates';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { getAuthRole } from 'shared/auth/AuthToken';

const RATE_TIME_WINDOW_DAYS = 90;

export function fitsRatingTimeWindow(date: NullableDateString) {
  const lastOrderActionDate = parseDate(date);
  if (!lastOrderActionDate.isValid) return false;
  return (
    Math.ceil(lastOrderActionDate.diffNow('days').days) * -1 <
    RATE_TIME_WINDOW_DAYS
  );
}

export function ratingTimeLeft(date: NullableDateString) {
  const lastOrderActionDate = parseDate(date);
  if (!lastOrderActionDate.isValid) return 0;
  return (
    RATE_TIME_WINDOW_DAYS + Math.ceil(lastOrderActionDate.diffNow('days').days)
  );
}

export function useIsRatingAvailable(date: NullableDateString) {
  const { data: carrierSettings } = useCarrierSettings();
  const isVerifiedCarrier =
    carrierSettings?.carrier.verification_status === 'approved';
  const authRole = getAuthRole();

  return (
    isVerifiedCarrier && (fitsRatingTimeWindow(date) || authRole === 'admin')
  );
}
